{{#> elements/_dt}}
  <label for="message_allowed">May we leave a message at this number?</label>
{{/elements/_dt}}
<dd>
  {{> elements/_input type="radio" value="Yes" checked="true" id="message_allowed_yes" }}
  <label for="message_allowed_yes">Yes</label>
</dd>
<dd>
  {{> elements/_input type="radio" value="No" id="message_allowed_no" }}
  <label for="message_allowed_no">No</label>
</dd>
